const translations = {
    noResults: 'No results found',
    placeholder: 'Search for an address'
};

export default translations;
